import { createApiRef } from '@backstage/frontend-plugin-api';
import { TechRadarStatusDto } from '@internal/backstage-plugin-techradar-evaluation-common';

export interface TechRadarApi {
  fetchStatus(entityRef: string): Promise<TechRadarStatusDto>;
}

export const techRadarApiRef = createApiRef<TechRadarApi>().with({
  id: 'plugin.catalog-module-techradar-card.techradar',
});
